export default class CompraDivida {
  constructor(consignacoes = [{}], proposta = {}) {
    this.consignacoes = consignacoes
    this.proposta = proposta
  }
}
